import request from '@/utils/request';

const state = {
  list: [],
};

const mutations = {
  SET_HOT_WORDS: (state, v) => {
    state.list = v;
  },
};

const actions = {
  getHotWords({ commit }, v) {
    return request
      .post(
        '/shop/listKeyWordBySellerId',
        {},
        {
          catchBusinessErr: true,
        }
      )
      .then(res => {
        const { data } = res.data;
        const list = data.sort((a, b) => b.sort - a.sort);
        commit('SET_HOT_WORDS', list);
      });
  },
};

const getters = {
  keyWordTypeHotWords(state, val) {
    // -> getters['account/isAdmin']
    return state.list.filter(t => t.keyWordType === 1);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
